module.exports = __webpack_public_path__ + "img/zu 390.51f6b483.png";